interface Step {
  name: string;
  id: number;
}

interface DriveSchedule {
  sku: {
    price: number;
    currency_code: string;
  };
}

export type Workflow = {
  id: number;
  title: string;
  status: string;
  steps: Step[];
  updated_by: number;
  updated_at: string;
  drive_schedule: DriveSchedule | null;
  updated_by_details: {
    email: string;
    name: string;
    id: number;
  };
  course: {
    id: number;
    name: string;
  };
};

export type FormatedWorkflowList = {
  id: number;
  title: string;
  updated_by_details: {
    email: string;
    name: string;
    id: number;
  } | null;
};

export type WorkflowCandidateList = {
  email: string;
  id: number;
  first_name: string;
  last_name: string | null;
  middle_name: string | null;
  external_id: string | null;
  workflow_candidate_steps: {
    step_id: number;
    step: Step;
    session_uuid: string;
  }[];
  workflow: {
    title: string;
    course: {
      id: number;
      name: string;
    };
  };
};

export const sessionType = {
  LIVE: 'Live',
  RECORDANDREVIEW: 'Record & review',
  RECORDED: 'Recorded',
};

export const sessionTypeList = [
  { label: 'live', value: sessionType.LIVE },
  { label: 'record&review', value: sessionType.RECORDANDREVIEW },
  { label: 'recorded', value: sessionType.RECORDED },
];

export const wftJobStatusTheme = {
  draft: { bg: 'bg-gray-100', text: 'text-gray-900' },
  closed: { bg: 'bg-orange-50', text: 'text-orange-600' },
  open: { bg: 'bg-blue-50', text: 'text-blue-900' },
  cancelled: { bg: 'bg-red-50', text: 'text-red-600' },
};

export const wftJobStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
};

export const wftJobStatusList = [
  {
    type: ['workflow'],
    key: wftJobStatus.DRAFT,
    label: 'Draft',
    theme: wftJobStatusTheme.draft,
  },
  {
    type: ['workflow'],
    key: wftJobStatus.OPEN,
    label: 'Open',
    theme: wftJobStatusTheme.open,
  },
  {
    type: ['workflow'],
    key: wftJobStatus.CLOSED,
    label: 'Closed',
    theme: wftJobStatusTheme.open,
  },
  {
    type: ['workflow'],
    key: wftJobStatus.CANCELLED,
    label: 'Cancelled',
    theme: wftJobStatusTheme.cancelled,
  },
];
